import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    fetchingListing: {},
};
export const listingReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            /*
            case actionTypes.CART_ACTIONS.DISABLE_FETCHING: {
                return {
                    ...state,
                    fetching: false
                }
            }
                */

        }
        return state;
    } catch (error) {
        return state;
    }
}
export default listingReducer;
